import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  constructor() {
  }

  setItem(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  getItem(key) {
    const data = localStorage.getItem(key);
    if (!data) {
      return false;
    } else {
      return JSON.parse(data);
    }
  }

  setProperty(propertyId: string, propertyName: string) {
    localStorage.setItem("SelectedProperty", JSON.stringify({ propertyId, propertyName }));
  }
  
  get property() {
    const data = localStorage.getItem("SelectedProperty");
    if (!data) {
      return undefined;
    }
    try {
      const prop = JSON.parse(data);
      if (prop.propertyId && prop.propertyName) {
        return prop;
      }
    } catch(e) {

    }
    return undefined;
  }

  clearProperty() {
    localStorage.removeItem("SelectedProperty");
    localStorage.removeItem("SelectedPropertyServiceTicket");
  }

  setServiceTicket(serviceId: string) {
    localStorage.setItem("SelectedPropertyServiceTicket", serviceId);
  }

  clearServiceTicket() {
    localStorage.removeItem("SelectedPropertyServiceTicket");
  }

  get serviceTicket() {
    const data = localStorage.getItem("SelectedPropertyServiceTicket");
    if (!data) {
      return undefined;
    }
    return data;
  }

}
